import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home')
    },
    {
      name: 'user',
      path: '/user',
      component: () => import('@/views/User')
    },
    {
      name: 'account',
      path: '/account',
      component: () => import('@/views/Account')
    },
    // {
    //   name: 'actions',
    //   path: '/prizes',
    //   component: () => import('@/views/Actions')
    // },
    {
      name: 'receipt',
      path: '/receipt',
      component: () => import('@/views/Receipt')
    },
    {
      name: 'receipts',
      path: '/receipts',
      component: () => import('@/views/Receipts')
    },
    // {
    //   name: 'extra',
    //   path: '/extra',
    //   component: () => import('@/views/Extra')
    // },
    // {
    //   name: 'questionnaire',
    //   path: '/questionnaire',
    //   component: () => import('@/views/Questionnaire')
    // },
    // {
    //   name: 'coupon',
    //   path: '/coupon',
    //   component: () => import('@/views/Coupon')
    // },
    {
      name: 'end',
      path: '/end',
      component: () => import('@/views/End')
    },
    {
      name: 'email-confirm',
      path: '/emailconfirm',
      component: () => import('@/views/EmailConfirm')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js